var f = Object.defineProperty, i = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var a = (e, o, r) => o in e ? f(e, o, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[o] = r, m = (e, o) => {
  for (var r in o || (o = {}))
    d.call(o, r) && a(e, r, o[r]);
  if (t)
    for (var r of t(o))
      l.call(o, r) && a(e, r, o[r]);
  return e;
}, p = (e, o) => i(e, c(o));
import s, { forwardRef as n } from "react";
import w from "../lib/IconBase.mjs";
import R from "../defs/Upload.mjs";
const U = n((e, o) => /* @__PURE__ */ s.createElement(w, p(m({ ref: o }, e), { weights: R })));
U.displayName = "Upload";
export {
  U as Upload
};
